/// <reference path="../include.ts" />

namespace project_guide {

	import Region = project_common.Region;
	import Area = project_common.Area;

	export class DrawerContentEvent extends alm.event.Event {

		public static requireGotoScene:string = 'DrawerContentEvent.requireGotoScene';





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, region:Region, area:Area) {
			super(eventType, target);
			this.region = region;
			this.area = area;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public readonly region:Region;
		public readonly area:Area;
	}
}
